import type React from 'react'
import type { ReactElement } from 'react'

export function IconAlertError(props: React.SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg width={24} height={24} xmlns={'http://www.w3.org/2000/svg'} viewBox={'0 0 24 24'} {...props}>
      <path
        d={
          'M11.0837 13.8333C11.0837 14.3396 11.4941 14.75 12.0003 14.75C12.5066 14.75 12.917 14.3396 12.917 13.8333L12.917 8.33333C12.917 7.82707 12.5066 7.41667 12.0003 7.41667C11.4941 7.41667 11.0837 7.82707 11.0837 8.33333L11.0837 13.8333Z'
        }
        fill={'currentcolor'}
      />
      <path
        d={
          'M11.0837 16.5833C11.0837 17.0896 11.4941 17.5 12.0003 17.5C12.5066 17.5 12.917 17.0896 12.917 16.5833V16.5742C12.917 16.0679 12.5066 15.6575 12.0003 15.6575C11.4941 15.6575 11.0837 16.0679 11.0837 16.5742V16.5833Z'
        }
        fill={'currentcolor'}
      />
      <path
        fillRule={'evenodd'}
        clipRule={'evenodd'}
        d={
          'M4.22185 4.22185C8.51765 -0.0739503 15.4823 -0.0739503 19.7782 4.22185C24.074 8.51765 24.074 15.4823 19.7782 19.7782C15.4823 24.074 8.51765 24.074 4.22185 19.7782C-0.0739503 15.4823 -0.0739503 8.51765 4.22185 4.22185ZM18.4818 5.51821C14.9019 1.93837 9.09805 1.93837 5.51821 5.51821C1.93837 9.09805 1.93837 14.9019 5.51821 18.4818C9.09805 22.0616 14.9019 22.0616 18.4818 18.4818C22.0616 14.9019 22.0616 9.09805 18.4818 5.51821Z'
        }
        fill={'currentcolor'}
      />
    </svg>
  )
}
